import script from "./ApresSkisCatalogo.vue?vue&type=script&setup=true&lang=js"
export * from "./ApresSkisCatalogo.vue?vue&type=script&setup=true&lang=js"

import "./ApresSkisCatalogo.vue?vue&type=style&index=0&id=0fef3b63&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fef3b63"]])

export default __exports__